import React, { useCallback, useRef } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import BackButton from '../../Button/BackButton'
import { makeStyles } from '@material-ui/core/styles'
import { gray } from '../../../utils/colors'


const WizardDialog = ({
	open,
	onBack,
	onClose,
	onNext,
	disableNext = false,
	disableBack = false,
	hideBack = false,
	hideFooter = false,
	loading = false,
	children, 
	ref
}) => {
	const classes = useStyles()
	const scrollRef = useRef()
	const handleOnBack = useCallback(() => {
		if (onBack) {
			onBack()
		}
	}, [onBack])

	const handleOnClose = useCallback(() => {
		if (onClose) {
			onClose()
		}
	}, [onClose])

	const handleOnNextClicked = useCallback(() => {
		if (onNext) {
			onNext()
		}
		scrollRef.current.scrollTo(0, 0)
	}, [onNext])

	return (
		<Dialog
			open={open}
			
			dialogRef={ref}
			PaperProps={{
				style: {
					width: 920,
					maxWidth: 920,
					minHeight: 650,
					minWidth: 920,
					padding: 0
				}
			}}>
			<DialogTitle>
				<div className={classes.header}>
					{onBack ? (
						<span style={{ flex: 1 }}>
							{!hideBack ? <BackButton onClicked={handleOnBack} disabled={disableBack} /> : null}
						</span>
					) : null}
					{onClose ? (
						<IconButton disableRipple style={{ padding: 0, flex: 0 }}>
							<Close onClick={handleOnClose} />
						</IconButton>
					) : null}
				</div>
			</DialogTitle>
			<DialogContent className={classes.sectionPadding} ref={scrollRef}>{children}</DialogContent>
			<DialogActions>
				{!hideFooter ? (
					<div className={classes.footerContainer}>
						{onNext ? (
							<Button
								disableElevation
								variant="contained"
								color="secondary"
								disabled={disableNext}
								onClick={handleOnNextClicked}>
								{loading ? 'Saving' : 'Next'}
							</Button>
						) : null}
					</div>
				) : null}
			</DialogActions>
		</Dialog>
	)
}

const useStyles = makeStyles(() => ({
	header: {
		display: 'flex',
		alignItems: 'center',
		padding: '1.1rem 1.5rem',
		'& .MuiIconButton-root': {
			'& .MuiIconButton-label': {
				'& svg': {
					fill: gray[700]
				}
			}
		}
	},
	sectionPadding: {
		padding: '1.5rem',
		paddingTop: 0,
		display: 'flex'
	},
	footerContainer: {
		display: 'flex',
		flex: 1,
		borderTop: '1px solid',
		borderColor: gray[500],
		justifyContent: 'flex-end',
		padding: '1.1rem 1.5rem'
	}
}))

export default WizardDialog
